<template>
  <div class="flex flex-col gap-1">
    <component
      :is="tag"
      :class="
        cn(
          'text-base font-semibold text-foreground leading-6',
          props.titleClass
        )
      "
    >
      <slot name="title">{{ title }}</slot>
    </component>
    <p
      v-if="description || $slots.description"
      :class="
        cn('text-sm text-muted-foreground leading-5', props.descriptionClass)
      "
    >
      <slot name="description">{{ description }}</slot>
    </p>
  </div>
</template>

<script setup>
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  title: { type: String, default: "" },
  description: { type: String, default: "" },
  tag: { type: String, default: "h2" },
  titleClass: { type: [String, Object, Array], default: undefined },
  descriptionClass: { type: [String, Object, Array], default: undefined },
});
</script>
